import React from 'react';
import { Link } from 'react-router-dom';

function AddButton() {
  return (
    <Link
      className="btn btn-primary btn-large new-btn-space"
      to={{ pathname: '/website/' }}
    >
      Add Website
    </Link>
  );
}

export default AddButton;
